import { createContext, useContext, type ReactNode } from 'react';
import type { RuntimeConfig } from './runtime';
import { createDefaultConfig } from './runtime';

const ConfigContext = createContext<RuntimeConfig>(createDefaultConfig());

export interface ConfigProviderProps {
  value: RuntimeConfig;
  children: ReactNode;
}

export const ConfigProvider = ({ value, children }: ConfigProviderProps) => {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
